export interface Game {
  id: number;
  name: string;
  image: string;
  players: string;
  points: number;
  folder: string;
  additionalImage?: string;
}

export const FEATURED_GAMES: Game[] = [
  {
    id: 1,
    name: 'Baseball Joe',
    image: 'assets/images/games/baseball.png',
    players: '1.2k',
    points: 300,
    folder: 'basketball-joe',
  },
  {
    id: 2,
    name: 'Ninja Gravity',
    image: 'assets/images/games/ninja.png',
    players: '856',
    points: 300,
    folder: 'ninja-gravity',
  },
  {
    id: 3,
    name: 'Hexa Blocks',
    image: 'assets/images/games/hexablocks.png',
    additionalImage: 'assets/images/games/hexablockstext.png',
    players: '642',
    points: 200,
    folder: 'hexa-blocks',
  },
];
